import { api } from '../lib/api';
import type { Email, UserSettings, EmailFolder } from '../types';

export async function getEmails(direction?: 'inbound' | 'outbound', opts?: { folderId?: string; ungrouped?: boolean }, limit = 50, offset = 0): Promise<Email[]> {
  const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  if (direction) params.set('direction', direction);
  if (opts?.folderId) params.set('folderId', opts.folderId);
  if (opts?.ungrouped) params.set('ungrouped', 'true');
  return api<Email[]>(`/api/emails?${params}`);
}

export async function getEmailFolders(): Promise<EmailFolder[]> {
  return api<EmailFolder[]>('/api/email-folders');
}

export async function createEmailFolder(name: string): Promise<EmailFolder> {
  return api<EmailFolder>('/api/email-folders', { method: 'POST', body: JSON.stringify({ name }) });
}

export async function updateEmailFolder(id: string, name: string): Promise<void> {
  await api(`/api/email-folders/${id}`, { method: 'PATCH', body: JSON.stringify({ name }) });
}

export async function deleteEmailFolder(id: string): Promise<void> {
  await api(`/api/email-folders/${id}`, { method: 'DELETE' });
}

export async function moveEmailToFolder(emailId: string, folderId: string | null): Promise<void> {
  await api(`/api/emails/${emailId}/folder`, { method: 'PATCH', body: JSON.stringify({ folderId }) });
}

export async function getUnreadCount(): Promise<number> {
  const res = await api<{ count: number }>('/api/emails/unread-count');
  return res.count;
}

export async function updateEmail(id: string, patch: { isRead?: boolean; isStarred?: boolean }): Promise<void> {
  await api(`/api/emails/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });
}

export async function getUserSettings(): Promise<UserSettings> {
  return api<UserSettings>('/api/auth/me');
}

export async function updateUserSettings(patch: { inboundHandle?: string | null; inboundHandle2?: string | null }): Promise<UserSettings> {
  return api<UserSettings>('/api/auth/me', { method: 'PATCH', body: JSON.stringify(patch) });
}

export async function checkHandleAvailability(handle: string): Promise<boolean> {
  const res = await api<{ available: boolean }>(`/api/auth/inbound-handle/check?handle=${encodeURIComponent(handle)}`);
  return res.available;
}
